import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Down from "../../assets/svg/down_arrow.svg";
import LogoSpc from "../../assets/images/logo.png";
import MenuIcon from "../../assets/svg/menu.svg";
import CloseIcon from "../../assets/svg/close.svg";
import DropdownSelect from "../DropdownSelect/DropdownSelect";
import "./NavbarComp.css";

function NavbarComp() {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedOption, setSelectedOption] = useState(() => {
    const storedOption = localStorage.getItem("selectedOption");
    return storedOption ? storedOption : "RegistrAtivos";
  });

  const dropdowns = {
    dropdown: {
      handleMouseEnter: () => setActiveDropdown("dropdown"),
      handleMouseLeave: () => setActiveDropdown(null),
      handleClick: () =>
        setActiveDropdown(activeDropdown === "dropdown" ? null : "dropdown"),
    },
    integration: {
      handleMouseEnter: () => setActiveDropdown("integration"),
      handleMouseLeave: () => setActiveDropdown(null),
      handleClick: () =>
        setActiveDropdown(activeDropdown === "integration" ? null : "integration"),
    },
  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);
    if (!showMenu) {
      return;
    }
    setActiveDropdown(null);
  };

  const triggerHash = () => {
    setActiveDropdown(null);
    setShowMenu(false);
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOptionChange = (value) => {
    setSelectedOption(value);
    localStorage.setItem("selectedOption", value);
  };

  useEffect(() => {
    const storedOption = localStorage.getItem("selectedOption");
    if (storedOption) {
      setSelectedOption(storedOption);
    }
  }, []);

  return (
    <nav className='navbar'>
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/">
            <img src={LogoSpc} alt="Logo" />
          </Link>
        </div>
        <div className="navbar-mobile">
          <button className="menu-toggle" onClick={toggleMenu}>
            <img src={showMenu ? CloseIcon : MenuIcon} alt="Menu Icon" />
          </button>
        </div>
        <ul className={`navbar-menu ${showMenu ? "show" : ""}`}>
          <li
            className='navbar-item' 
          >
            <Link to="/" onClick={triggerHash}>
              Início
            </Link>
          </li>
          <li
            className='navbar-item'
            onMouseEnter={
              !isMobile ? dropdowns.dropdown.handleMouseEnter : null
            }
            onMouseLeave={
              !isMobile ? dropdowns.dropdown.handleMouseLeave : null
            }
            onClick={isMobile ? dropdowns.dropdown.handleClick : null}
          >
            <button>
              Docs
              <img
                src={!showMenu && Down}
                alt="Arrow-Down"
                className={
                  activeDropdown === "dropdown" ? "flip-up" : "flip-down"
                }
              />
            </button>
            {activeDropdown === "dropdown" && (
              <div
                className="dropdown-content"
                onMouseEnter={
                  !isMobile ? dropdowns.dropdown.handleMouseEnter : null
                }
                onMouseLeave={
                  !isMobile ? dropdowns.dropdown.handleMouseLeave : null
                }
              >
                 <DropdownSelect
                  options={[
                    { value: "RegistrAtivos", label: "RegistrAtivos" },
                    { value: "BuscAtivos", label: "BuscAtivos" },
                    { value: "CapturAtivos", label: "CapturAtivos" },
                    { value: "BookVariaveis", label: "Book de variáveis" },
                    { value: "Escrituradora", label: "Escrituradora" },
                  ]}
                  onSelect={handleOptionChange}
                  value={selectedOption}
                />

                {selectedOption === "RegistrAtivos" && (
                  <>
                    <div className="dropdown-section1">
                      <h3 className="dropdown-title">&nbsp;</h3>
                      <ul>
                        <li>
                          <Link
                            to="/registrativos#893gi9lwxfmlh-introducao"
                            onClick={triggerHash}
                          >
                            Introdução
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/registrativos#096qde65y8864-ambientes-e-pre-requisitos"
                            onClick={triggerHash}
                          >
                            Ambientes e Pré-requisitos
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/registrativos#9uihdvrq91vch-criando-o-usuario-de-api"
                            onClick={triggerHash}
                          >
                            Criação de Usuário
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/registrativos#/pdghwgyq62ifk-usando-a-api"
                            onClick={triggerHash}
                          >
                            Usando a API
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/registrativos#ihwhet2v78sdq-roteiro-de-testes"
                            onClick={triggerHash}
                          >
                            Roteiro de testes
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/registrativos#lkjmk994m6lb7-webhook-do-sistema-spc-grafeno"
                            onClick={triggerHash}
                          >
                            Webhook
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/registrativos#l2ggiqyqgpjx2-glossario"
                            onClick={triggerHash}
                          >
                            Glossário
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="dropdown-section-divider"></div>
                    <div className="dropdown-section2">
                      <h3 className="dropdown-title">Módulos da API</h3>
                      <ul>
                        <li>
                          <Link
                            to="/registrativos#i0y8qy85xelh3-autenticacao-e-token"
                            onClick={triggerHash}
                          >
                            Token
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/registrativos#usnziuinriyz4-registr-ativo"
                            onClick={triggerHash}
                          >
                            RegistrAtivos
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/registrativos#c6kcimooonnj1-outras-funcionalidades"
                            onClick={triggerHash}
                          >
                            Outras funcionalidades
                          </Link>
                        </li>
                        {/* <li>
                          <Link
                            to="/registrativos#wms2frh8of3o9-outras-funcionalidades"
                            onClick={triggerHash}
                          >
                            Outras funcionalidades
                          </Link>
                        </li> */}
                      </ul>
                    </div>
                    <div className="dropdown-section3">
                      <ul>
                        <li>
                          <Link
                            to="/registrativos#i0y8qy85xelh3-autenticacao-e-token"
                            onClick={triggerHash}
                            className="guides"
                          >
                            Guides
                          </Link>
                          <span className="dropdown-link-separator"> | </span>
                          <Link
                            to="/registrativos#oa18r8cmt3z0q-gerar-um-token-de-acesso-para-realizar-requisicao-as-ap-is"
                            onClick={triggerHash}
                            className="api-reference"
                          >
                            API Reference
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/registrativos#usnziuinriyz4-registr-ativo"
                            onClick={triggerHash}
                            className="guides"
                          >
                            Guides
                          </Link>
                          <span className="dropdown-link-separator"> | </span>
                          <Link
                            to="/registrativos#0uj7l3pj6kdc7-criar-remessa-de-registro-de-duplicatas"
                            onClick={triggerHash}
                            className="api-reference"
                          >
                            API Reference
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/registrativos#c6kcimooonnj1-outras-funcionalidades"
                            onClick={triggerHash}
                            className="guides"
                          >
                            Guides
                          </Link>
                          <span className="dropdown-link-separator"> | </span>
                          <Link
                            to="/registrativos#72lgx935f1z1k-listar-os-vinculos-de-participante-autorizado"
                            onClick={triggerHash}
                            className="api-reference"
                          >
                            API Reference
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </>
                )}
                {selectedOption === "BuscAtivos" && (
                  <>
                    <div className="dropdown-section1">
                      <h3 className="dropdown-title">&nbsp;</h3>
                      <ul>
                        <li>
                          <Link
                            to="/buscativos#8r5y3j9ln0pgv-introducao"
                            onClick={triggerHash}
                          >
                            Introdução
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/buscativos#82474armurp1n-ambientes-e-pre-requisitos"
                            onClick={triggerHash}
                          >
                            Ambientes e Pré-requisitos
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/buscativos#e75ce6ku3t8v1-criando-o-usuario-de-api"
                            onClick={triggerHash}
                          >
                            Criação de Usuário
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/buscativos#ss9k35dd663t7-usando-a-api"
                            onClick={triggerHash}
                          >
                            Usando a API
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="dropdown-section-divider"></div>
                    <div className="dropdown-section2">
                      <h3 className="dropdown-title">Módulos da API</h3>
                      <ul>
                        <li>
                          <Link
                            to="/buscativos#hcxlukrbcf23o-autenticacao-e-token"
                            onClick={triggerHash}
                          >
                            Token
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/buscativos#ccum0xkv4ssbt-busc-ativo"
                            onClick={triggerHash}
                          >
                            BuscAtivos
                          </Link>
                        </li>
                        {/* <li>
                        <Link
                          to="/buscativos#wms2frh8of3o9-outras-funcionalidades"
                          onClick={triggerHash}
                        >
                          Outras funcionalidades
                        </Link>
                      </li> */}
                      </ul>
                    </div>
                    <div className="dropdown-section3">
                      <ul>
                        <li>
                          <Link
                            to="/buscativos#hcxlukrbcf23o-autenticacao-e-token"
                            onClick={triggerHash}
                            className="guides"
                          >
                            Guides
                          </Link>
                          <span className="dropdown-link-separator"> | </span>
                          <Link
                            to="/buscativos#rt61akof7dj8o-gerar-um-token-de-acesso-para-realizar-requisicao-as-ap-is"
                            onClick={triggerHash}
                            className="api-reference"
                          >
                            API Reference
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/buscativos#ccum0xkv4ssbt-busc-ativo"
                            onClick={triggerHash}
                            className="guides"
                          >
                            Guides
                          </Link>
                          <span className="dropdown-link-separator"> | </span>
                          <Link
                            to="/buscativos#k6f2ygb3um32c-listar-consultas-de-cc-bs-na-interop"
                            onClick={triggerHash}
                            className="api-reference"
                          >
                            API Reference
                          </Link>
                        </li>
                        {/* <li>
                        <Link
                          to="/buscativos#3umx7xsi7wwi4-registr-ativo"
                          onClick={triggerHash}
                          className="guides"
                        >
                          Guides
                        </Link>
                        <span className="dropdown-link-separator"> | </span>
                        <Link
                          to="/buscativos#ef8dc360a9612-criar-uma-remessa-de-registro-de-duplicatas"
                          onClick={triggerHash}
                          className="api-reference"
                        >
                          API Reference
                        </Link>
                      </li> */}
                      </ul>
                    </div>
                  </>
                )}
                {selectedOption === "CapturAtivos" && (
                  <>
                    <div className="dropdown-section1">
                      <h3 className="dropdown-title">&nbsp;</h3>
                      <ul>
                        <li>
                          <Link
                            to="/capturativos#/893gi9lwxfmlh-introducao"
                            onClick={triggerHash}
                          >
                            Introdução
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/capturativos#/096qde65y8864-ambientes-e-pre-requisitos"
                            onClick={triggerHash}
                          >
                            Ambientes e Pré-requisitos
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/capturativos#/9uihdvrq91vch-criando-o-usuario-de-api"
                            onClick={triggerHash}
                          >
                            Criação de Usuário
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/capturativos#/pdghwgyq62ifk-usando-a-api"
                            onClick={triggerHash}
                          >
                            Usando a API
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="dropdown-section-divider"></div>
                    <div className="dropdown-section2">
                      <h3 className="dropdown-title">Módulos da API</h3>
                      <ul>
                        <li>
                          <Link
                            to="/capturativos#/i0y8qy85xelh3-autenticacao-e-token"
                            onClick={triggerHash}
                          >
                            Token
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/capturativos#/tw8c3zh77gh2z-documentacao-da-api-consulta-de-nota-fiscal-eletronica-n-fe"
                            onClick={triggerHash}
                          >
                            CapturAtivos
                          </Link>
                        </li>
                        {/* <li>
                        <Link
                          to="/buscativos#wms2frh8of3o9-outras-funcionalidades"
                          onClick={triggerHash}
                        >
                          Outras funcionalidades
                        </Link>
                      </li> */}
                      </ul>
                    </div>
                    <div className="dropdown-section3">
                      <ul>
                        <li>
                          <Link
                            to="/capturativos#/i0y8qy85xelh3-autenticacao-e-token"
                            onClick={triggerHash}
                            className="guides"
                          >
                            Guides
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/capturativos#/tw8c3zh77gh2z-documentacao-da-api-consulta-de-nota-fiscal-eletronica-n-fe"
                            onClick={triggerHash}
                            className="guides"
                          >
                            Guides
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </>
                )}
                {selectedOption === "BookVariaveis" && (
                  <>
                    <div className="dropdown-section1">
                      <h3 className="dropdown-title">&nbsp;</h3>
                      <ul>
                        <li>
                          <Link
                            to="/bookvariaveis#/4yrhqy59pc8yf-introducao"
                            onClick={triggerHash}
                          >
                            Introdução
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/bookvariaveis#/e77ejl4mzne7u-ambientes-e-pre-requisitos"
                            onClick={triggerHash}
                          >
                            Ambientes e Pré-requisitos
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/bookvariaveis#/fs6txk95gy83w-criando-o-usuario-de-api"
                            onClick={triggerHash}
                          >
                            Criação de Usuário
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="dropdown-section-divider"></div>
                    <div className="dropdown-section2">
                      <h3 className="dropdown-title">Módulos da API</h3>
                      <ul>
                        <li>
                          <Link
                            to="/bookvariaveis#/7vq435a2r2rwo-autenticacao-e-token"
                            onClick={triggerHash}
                          >
                            Token
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/bookvariaveis#/08ftwza9xuxa8-book"
                            onClick={triggerHash}
                          >
                            Book de variáveis
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="dropdown-section3">
                      <ul>
                        <li>
                          <Link
                            to="/bookvariaveis#/7vq435a2r2rwo-autenticacao-e-token"
                            onClick={triggerHash}
                            className="guides"
                          >
                            Guides
                          </Link>
                          <span className="dropdown-link-separator"> | </span>
                          <Link
                            to="/registrativos#/oa18r8cmt3z0q-gerar-um-token-de-acesso-para-realizar-requisicao-as-ap-is"
                            onClick={triggerHash}
                            className="api-reference"
                          >
                            API Reference
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/bookvariaveis#/08ftwza9xuxa8-book"
                            onClick={triggerHash}
                            className="guides"
                          >
                            Guides
                          </Link>
                          <span className="dropdown-link-separator"> | </span>
                          <Link
                            to="/bookvariaveis#/eyashmobk8oj0-enqueue-batch"
                            onClick={triggerHash}
                            className="api-reference"
                          >
                            API Reference
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </>
                )}
                {selectedOption === "Escrituradora" && (
                  <>
                    <div className="dropdown-section1">
                      <h3 className="dropdown-title">&nbsp;</h3>
                      <ul>
                        <li>
                          <Link
                            to="/escrituradora#/icarfkyvpjpk8-portal-de-ap-is-spc-grafeno"
                            onClick={triggerHash}
                          >
                            Introdução
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/escrituradora#/f2a150b2591d4-autenticacao"
                            onClick={triggerHash}
                          >
                            Autenticação        
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/escrituradora#/zw2lybfb0pont-escrituradora"
                            onClick={triggerHash}
                          >
                            Escrituradora
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </>
                )}
                {/* {selectedOption === "MonitorAtivos" && (
                  <>
                  <div className="dropdown-section1">
                    <h3 className="dropdown-title">&nbsp;</h3>

                    <ul>
                      <li>
                        <Link to="/docs#hz6lxvrr0m7wo-0-introducao" onClick={triggerHash}>
                          Introdução
                        </Link>
                      </li>
                      <li>
                        <Link to="/docs#yqshxjom0gyy4-ambientes-e-pre-requisitos" onClick={triggerHash}>
                          Ambientes e Pré-requisitos
                        </Link>
                      </li>
                      <li>
                        <Link to="/docs#tentv8klqk3ir-criando-o-usuario-de-api" onClick={triggerHash}>
                          Criação de Usuário
                        </Link>
                      </li>
                      <li>
                        <Link to="/docs#749b8ccb904fb-usando-a-api" onClick={triggerHash}>
                          Usando a API
                        </Link>
                      </li>
                    </ul>
                  </div>
                 <div className="dropdown-section-divider"></div>
                  <div className="dropdown-section2">
                    <h3 className="dropdown-title">Módulos da API</h3>
                    <ul>
                      <li>
                        <Link
                          to="/docs#cdcwqbdp7bw6o-autenticacao-e-token"
                          onClick={triggerHash}
                        >
                          Token
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/docs#3umx7xsi7wwi4-registr-ativo"
                          onClick={triggerHash}
                        >
                         MonitorAtivos
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/docs#wms2frh8of3o9-outras-funcionalidades"
                          onClick={triggerHash}
                        >
                          Outras funcionalidades
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="dropdown-section3">
                    <ul>
                      <li>
                        <Link
                          to="/docs#cdcwqbdp7bw6o-autenticacao-e-token"
                          onClick={triggerHash}
                          className="guides"
                        >
                          Guides
                        </Link>
                        <span className="dropdown-link-separator"> | </span>
                        <Link
                          to="/docs#d85f183c812cf-cria-um-novo-token-e-retorna-no-header"
                          onClick={triggerHash}
                          className="api-reference"
                        >
                          API Reference
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/docs#yyvuxegqc009g-cadastr-ativo"
                          onClick={triggerHash}
                          className="guides"
                        >
                          Guides
                        </Link>
                        <span className="dropdown-link-separator"> | </span>
                        <Link
                          to="/docs#fcd047c87479a-lista-de-itens-de-uma-remessa"
                          onClick={triggerHash}
                          className="api-reference"
                        >
                          API Reference
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/docs#3umx7xsi7wwi4-registr-ativo"
                          onClick={triggerHash}
                          className="guides"
                        >
                          Guides
                        </Link>
                        <span className="dropdown-link-separator"> | </span>
                        <Link
                          to="/docs#ef8dc360a9612-criar-uma-remessa-de-registro-de-duplicatas"
                          onClick={triggerHash}
                          className="api-reference"
                        >
                          API Reference
                        </Link>
                      </li>
                    </ul>
                  </div>
                </>
                )} */}
                {/* {selectedOption === "ValidAtivos" && (
                  <>
                  <div className="dropdown-section1">
                    <h3 className="dropdown-title">&nbsp;</h3>

                    <ul>
                      <li>
                        <Link to="/docs#hz6lxvrr0m7wo-0-introducao" onClick={triggerHash}>
                          Introdução
                        </Link>
                      </li>
                      <li>
                        <Link to="/docs#yqshxjom0gyy4-ambientes-e-pre-requisitos" onClick={triggerHash}>
                          Ambientes e Pré-requisitos
                        </Link>
                      </li>
                      <li>
                        <Link to="/docs#tentv8klqk3ir-criando-o-usuario-de-api" onClick={triggerHash}>
                          Criação de Usuário
                        </Link>
                      </li>
                      <li>
                        <Link to="/docs#749b8ccb904fb-usando-a-api" onClick={triggerHash}>
                          Usando a API
                        </Link>
                      </li>
                    </ul>
                  </div>
                 <div className="dropdown-section-divider"></div>
                  <div className="dropdown-section2">
                    <h3 className="dropdown-title">Módulos da API</h3>
                    <ul>
                      <li>
                        <Link
                          to="/docs#cdcwqbdp7bw6o-autenticacao-e-token"
                          onClick={triggerHash}
                        >
                          Token
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/docs#3umx7xsi7wwi4-registr-ativo"
                          onClick={triggerHash}
                        >
                          ValidAtivos
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/docs#wms2frh8of3o9-outras-funcionalidades"
                          onClick={triggerHash}
                        >
                          Outras funcionalidades
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="dropdown-section3">
                    <ul>
                      <li>
                        <Link
                          to="/docs#cdcwqbdp7bw6o-autenticacao-e-token"
                          onClick={triggerHash}
                          className="guides"
                        >
                          Guides
                        </Link>
                        <span className="dropdown-link-separator"> | </span>
                        <Link
                          to="/docs#d85f183c812cf-cria-um-novo-token-e-retorna-no-header"
                          onClick={triggerHash}
                          className="api-reference"
                        >
                          API Reference
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/docs#yyvuxegqc009g-cadastr-ativo"
                          onClick={triggerHash}
                          className="guides"
                        >
                          Guides
                        </Link>
                        <span className="dropdown-link-separator"> | </span>
                        <Link
                          to="/docs#fcd047c87479a-lista-de-itens-de-uma-remessa"
                          onClick={triggerHash}
                          className="api-reference"
                        >
                          API Reference
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/docs#3umx7xsi7wwi4-registr-ativo"
                          onClick={triggerHash}
                          className="guides"
                        >
                          Guides
                        </Link>
                        <span className="dropdown-link-separator"> | </span>
                        <Link
                          to="/docs#ef8dc360a9612-criar-uma-remessa-de-registro-de-duplicatas"
                          onClick={triggerHash}
                          className="api-reference"
                        >
                          API Reference
                        </Link>
                      </li>

                    </ul>
                  </div>
                </>
                )} */}
              </div>
            )}
          </li>

          <li
            className='navbar-item'
          >
            <Link to="/registrativos#/oh1pmiexvcpyn-registradora" onClick={triggerHash}>
              API Reference
            </Link>
          </li>
          <li
            className='navbar-item'
          >
            <Link to="/collection" onClick={triggerHash}>
              Collection
            </Link>
          </li>
          <li
            className='navbar-item'
            onMouseEnter={
              !isMobile ? dropdowns.integration.handleMouseEnter : null
            }
            onMouseLeave={
              !isMobile ? dropdowns.integration.handleMouseLeave : null
            }
            onClick={isMobile ? dropdowns.integration.handleClick : null}
          >
            <button>
              Solicitar Integração
              <img
                src={!showMenu && Down}
                alt="Arrow-Down"
                className={
                  activeDropdown === "integration" ? "flip-up" : "flip-down"
                }
              />
            </button>
            {activeDropdown === "integration" && (
              <div
                className="dropdown-integration"
                onMouseEnter={
                  !isMobile ? dropdowns.integration.handleMouseEnter : null
                }
                onMouseLeave={
                  !isMobile ? dropdowns.integration.handleMouseLeave : null
                }
              >
                <ul>
                  <li>
                    <Link to="/integracao-webhook" onClick={triggerHash}>
                      Webhook
                    </Link>
                  </li>
                  <li>
                    <Link to="/integracao-api" onClick={triggerHash}>
                      Via API
                    </Link>
                  </li>
                </ul>
              </div>
            )}
          </li>
          {/* <li className='navbar-item'>
            <Link to="/docs#lkqp8tgn70zk7-release-notes" onClick={triggerHash}>
              Release Notes
            </Link>
          </li> */}
          <li
            className='navbar-item'
          >
            <Link to="/faq-support" onClick={triggerHash}>
              Suporte
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavbarComp;
